import { UserRefundProgramList } from '@/domain/usecases/refund/user-refund-program-list'
import { queryClient } from '@/infra/http'
import { QueryClient } from '@tanstack/react-query'

/**
 * Loads refund program list for current user
 * Simple loader that fetches all available refund programs
 */
export async function loadRefundProgramList() {
  const module = await import('@/main/factories/usecases')
  const makeRemote = module.makeRemoteUserRefundProgramList as (
    queryClient: QueryClient
  ) => UserRefundProgramList
  const remote = makeRemote(queryClient)
  return remote.get()
}
